/*-----------------------------------------------------------------
- Breadcrumbs translations
-----------------------------------------------------------------*/
export default {
    
    commenting    : 'دیدگاه‌ها',
    comment_single: 'مشاهده دیدگاه',
    
};
